import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, Text, View } from './components/base_components';
import { useBusy, BusyOverlay } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';
import PropList from './components/prop_list';
import StandardBoxList from './components/standard_box_list';
import TextButton from './components/buttons/text_button';

import OrgStore from './stores/org_store';

const styles = StyleSheet.create({
  orgListScreen: {
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  text: {
    marginLeft: '2rem',
    marginTop: '1.5em',
    fontSize: '1.5em',
  },
  button: {
    marginLeft: '1rem',
  },
  bottomLine: {
    alignSelf: 'stretch',
    height: '5rem',
    backgroundColor: 'var(--box-header-bg-color)',
    borderTopWidth: 1,
    borderColor: 'var(--box-inner-line-color)',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
});

export default function OrgListScreen(props) {
  const [org_name, setOrgName] = React.useState('');
  const org_list = OrgStore.useOrgList();
  const [is_busy, setBusy, clearBusy] = useBusy();
  const navigate = useNavigate();
  React.useEffect(() => {
    OrgStore.fetch();
  }, []);

  function _onAddOrg() {
    if (org_name && setBusy()) {
      OrgStore.createOrg({ org_name }, (err, org_id) => {
        clearBusy();
        if (err === 409) {
          window.alert('Org name already in use.');
        } else if (err) {
          window.alert('Create failed, please try again.');
        } else {
          navigate(`/org/${org_id}`);
        }
      });
    }
  }

  let content: any = null;
  if (!org_list) {
    content = <ProgressSpinner />;
  }
  const headers = [
    'Org Name',
    'Device Count',
    'User Count',
    'Volume Count',
    'Plan',
  ];
  const sizes = [3];
  return (
    <View style={styles.orgListScreen}>
      <StandardBoxList
        title='Orgs'
        detail={org_list?.length}
        headers={headers}
        sizes={sizes}
        rows={org_list?.map?.((org: any) => ({
          url: '/org/' + org?.org_id,
          list: [
            org.org_name,
            org.device_count || '-',
            org.user_count || '-',
            org.volume_count || '-',
            org.plan_id || '-',
          ],
        }))}
      >
        {content}
      </StandardBoxList>
      <StandardBoxList title='Add Org'>
        <Text style={styles.text}>Add a new organization</Text>
        <PropList
          editing={true}
          columns={[
            [
              {
                key: 'org_name',
                label: 'Org Name',
                value: org_name,
                input: {
                  placeholder: 'Org Name',
                  onChangeText: setOrgName,
                },
              },
            ],
          ]}
        />
        <View style={styles.bottomLine}>
          <TextButton
            style={styles.button}
            text='Add Org'
            onPress={_onAddOrg}
          />
        </View>
      </StandardBoxList>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
